import { LayoutTemplate } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function BrandSection({ brand, setBrand }) {
  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <LayoutTemplate size={18} className="text-[#1f3a8a]" /> Strona główna i kontakt
      </h3>
      <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 space-y-4">
        <div>
          <label className={labelCls}>Hasło marki (tagline w stopce) — można wpisać wielolinijkowo</label>
          <textarea data-testid="brand-tagline" className={inputCls} rows={2} value={brand.tagline} onChange={(e) => setBrand({ ...brand, tagline: e.target.value })} placeholder="Sieć, która działa dla Ciebie. Polska sieć komórkowa z przejrzystymi cenami." />
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Nadtytuł hero (eyebrow)</label>
            <input data-testid="hero-eyebrow" className={inputCls} value={brand.hero.eyebrow} onChange={(e) => setBrand({ ...brand, hero: { ...brand.hero, eyebrow: e.target.value } })} />
          </div>
          <div>
            <label className={labelCls}>Godziny infolinii (2 linijki jedna pod drugą)</label>
            <textarea
              data-testid="contact-hours"
              className={inputCls}
              rows={2}
              value={brand.contact.hours}
              onChange={(e) => setBrand({ ...brand, contact: { ...brand.contact, hours: e.target.value } })}
              placeholder={"pn-pt: 08:00-22:00\nsobota: 09:00-20:00"}
            />
          </div>
        </div>

        {/* Rozmiar eyebrow + prędkość flagi */}
        <div className="grid md:grid-cols-2 gap-4 border-t border-slate-200 pt-4">
          <div>
            <label className={labelCls}>Rozmiar tekstu „Nasza Telefonia Komórkowa"</label>
            <select
              data-testid="hero-eyebrow-size"
              className={inputCls}
              value={brand.hero_eyebrow_style?.size || "md"}
              onChange={(e) => setBrand({ ...brand, hero_eyebrow_style: { ...(brand.hero_eyebrow_style || {}), size: e.target.value } })}
            >
              <option value="sm">Mały</option>
              <option value="md">Średni (domyślny)</option>
              <option value="lg">Duży</option>
              <option value="xl">Bardzo duży</option>
            </select>
          </div>
          <div>
            <label className={labelCls}>
              Prędkość animacji flagi (sekundy):{" "}
              <span className="text-slate-800 font-bold">{brand.hero_eyebrow_style?.flag_speed_sec ?? 12}s</span>
              <span className="text-slate-400 font-normal ml-2 normal-case">(mniej = szybciej)</span>
            </label>
            <input
              data-testid="hero-flag-speed"
              type="range"
              min="2"
              max="60"
              step="1"
              value={brand.hero_eyebrow_style?.flag_speed_sec ?? 12}
              onChange={(e) => setBrand({ ...brand, hero_eyebrow_style: { ...(brand.hero_eyebrow_style || {}), flag_speed_sec: Number(e.target.value) } })}
              className="w-full mt-2 accent-[#1f3a8a]"
            />
          </div>
        </div>
        <div>
          <label className={labelCls}>Nagłówek główny (hero title) — Enter dzieli na dwie linie</label>
          <textarea data-testid="hero-title" className={inputCls} rows={2} value={brand.hero.title} onChange={(e) => setBrand({ ...brand, hero: { ...brand.hero, title: e.target.value } })} />

          {/* Formatowanie nagłówka „hero title" */}
          <div className="mt-3 rounded-lg border border-slate-200 bg-white p-3 space-y-3">
            <div className="text-xs font-bold text-slate-600 uppercase tracking-wider">Formatowanie tekstu</div>
            <div className="grid md:grid-cols-4 gap-3">
              <div>
                <label className={labelCls}>Czcionka</label>
                <select
                  data-testid="hero-title-font"
                  className={inputCls}
                  value={brand.hero_title_style?.font_family || "manrope"}
                  onChange={(e) => setBrand({ ...brand, hero_title_style: { ...(brand.hero_title_style || {}), font_family: e.target.value } })}
                >
                  <option value="manrope">Manrope (domyślna)</option>
                  <option value="inter">Inter</option>
                  <option value="roboto">Roboto</option>
                  <option value="lato">Lato</option>
                  <option value="poppins">Poppins</option>
                  <option value="playfair">Playfair Display (serif)</option>
                  <option value="merriweather">Merriweather (serif)</option>
                  <option value="bebas">Bebas Neue</option>
                  <option value="oswald">Oswald</option>
                </select>
              </div>
              <div>
                <label className={labelCls}>Rozmiar</label>
                <select
                  data-testid="hero-title-size"
                  className={inputCls}
                  value={brand.hero_title_style?.size || "3xl"}
                  onChange={(e) => setBrand({ ...brand, hero_title_style: { ...(brand.hero_title_style || {}), size: e.target.value } })}
                >
                  <option value="xs">XS – Bardzo mały</option>
                  <option value="sm">S – Mały</option>
                  <option value="md">M – Średni</option>
                  <option value="lg">L – Duży</option>
                  <option value="xl">XL – Bardzo duży</option>
                  <option value="2xl">2XL</option>
                  <option value="3xl">3XL (domyślny)</option>
                  <option value="4xl">4XL – Wielki</option>
                  <option value="5xl">5XL – Ogromny</option>
                </select>
              </div>
              <div>
                <label className={labelCls}>Grubość</label>
                <select
                  data-testid="hero-title-weight"
                  className={inputCls}
                  value={brand.hero_title_style?.weight || 900}
                  onChange={(e) => setBrand({ ...brand, hero_title_style: { ...(brand.hero_title_style || {}), weight: Number(e.target.value) } })}
                >
                  <option value={100}>100 – Cienka (thin)</option>
                  <option value={200}>200 – Extra light</option>
                  <option value={300}>300 – Light</option>
                  <option value={400}>400 – Regular</option>
                  <option value={500}>500 – Medium</option>
                  <option value={600}>600 – Semibold</option>
                  <option value={700}>700 – Bold</option>
                  <option value={800}>800 – Extra bold</option>
                  <option value={900}>900 – Black (domyślna)</option>
                </select>
              </div>
              <div>
                <label className={labelCls}>Kursywa</label>
                <label className="flex items-center gap-2 h-[38px] px-3 rounded-md border border-slate-300 bg-white text-sm text-slate-700 cursor-pointer">
                  <input
                    type="checkbox"
                    data-testid="hero-title-italic"
                    checked={!!brand.hero_title_style?.italic}
                    onChange={(e) => setBrand({ ...brand, hero_title_style: { ...(brand.hero_title_style || {}), italic: e.target.checked } })}
                    className="w-4 h-4"
                  />
                  <span>Włącz kursywę</span>
                </label>
              </div>
            </div>
            <div className="text-[11px] text-slate-500">
              Podgląd (~jak na stronie głównej):
              <div
                className={`mt-1 text-white bg-[#0f2560] rounded px-3 py-2 ${brand.hero_title_style?.italic ? "italic" : ""}`}
                style={{
                  fontFamily: ({
                    manrope: "'Manrope', system-ui, sans-serif",
                    inter: "'Inter', system-ui, sans-serif",
                    roboto: "'Roboto', system-ui, sans-serif",
                    lato: "'Lato', system-ui, sans-serif",
                    poppins: "'Poppins', system-ui, sans-serif",
                    playfair: "'Playfair Display', Georgia, serif",
                    merriweather: "'Merriweather', Georgia, serif",
                    bebas: "'Bebas Neue', Impact, sans-serif",
                    oswald: "'Oswald', Impact, sans-serif",
                  })[brand.hero_title_style?.font_family || "manrope"],
                  fontWeight: brand.hero_title_style?.weight || 900,
                  fontSize: ({
                    xs: "14px", sm: "18px", md: "22px", lg: "26px", xl: "30px",
                    "2xl": "34px", "3xl": "38px", "4xl": "44px", "5xl": "52px",
                  })[brand.hero_title_style?.size || "3xl"],
                  lineHeight: 1.1,
                }}
              >
                {brand.hero.title || "Republika mobile łączymy pokolenia"}
              </div>
            </div>
          </div>
        </div>
        <div>
          <label className={labelCls}>Podtytuł hero (opis pod nagłówkiem)</label>
          <textarea data-testid="hero-subtitle" className={inputCls} rows={2} value={brand.hero.subtitle} onChange={(e) => setBrand({ ...brand, hero: { ...brand.hero, subtitle: e.target.value } })} />
        </div>

        {/* Toggle: pokazuj przycisk "Przenieś numer" pod "Zobacz abonamenty" (hero) */}
        <div className="rounded-lg border border-slate-200 bg-white p-3">
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              data-testid="hero-cta-port-enabled"
              checked={brand.hero?.cta_port_enabled !== false}
              onChange={(e) => setBrand({ ...brand, hero: { ...brand.hero, cta_port_enabled: e.target.checked } })}
              className="w-4 h-4 mt-0.5"
            />
            <div>
              <div className="text-sm font-bold text-slate-800">
                Pokazuj przycisk „Przenieś numer" w hero (pod „Zobacz abonamenty")
              </div>
              <div className="text-xs text-slate-500 mt-1">
                Dotyczy zarówno widoku desktop jak i mobile.
              </div>
            </div>
          </label>
        </div>

        {/* === Zegar odliczający do startu sprzedaży === */}
        <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 space-y-3">
          <div className="flex items-center justify-between">
            <div className="text-xs font-bold text-slate-600 uppercase tracking-wider">Zegar odliczający do startu sprzedaży</div>
            <label className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
              <input
                type="checkbox"
                data-testid="countdown-enabled"
                checked={brand.countdown?.enabled !== false}
                onChange={(e) => setBrand({ ...brand, countdown: { ...(brand.countdown || {}), enabled: e.target.checked } })}
                className="w-4 h-4"
              />
              <span className="font-semibold">Pokazuj na stronie głównej</span>
            </label>
          </div>
          <div className={`grid md:grid-cols-2 gap-3 ${brand.countdown?.enabled === false ? "opacity-40 pointer-events-none" : ""}`}>
            <div>
              <label className={labelCls}>Napis nad zegarem</label>
              <input
                data-testid="countdown-label"
                className={inputCls}
                value={brand.countdown?.label || ""}
                onChange={(e) => setBrand({ ...brand, countdown: { ...(brand.countdown || {}), label: e.target.value } })}
                placeholder="Start za"
              />
            </div>
            <div>
              <label className={labelCls}>Data i godzina startu sprzedaży</label>
              <input
                type="datetime-local"
                data-testid="countdown-target"
                className={inputCls}
                value={(brand.countdown?.target_at || "").slice(0, 16)}
                onChange={(e) => setBrand({ ...brand, countdown: { ...(brand.countdown || {}), target_at: e.target.value ? `${e.target.value}:00` : "" } })}
              />
              <div className="text-[11px] text-slate-500 mt-1">
                Format: rok-miesiąc-dzień godzina:minuty (czas lokalny).
              </div>
            </div>
          </div>

          {/* === Blokada zamówień przed startem sprzedaży === */}
          <div className="mt-2 pt-3 border-t border-slate-200">
            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                data-testid="sales-lock-enabled"
                checked={brand.sales_lock_enabled !== false}
                onChange={(e) => setBrand({ ...brand, sales_lock_enabled: e.target.checked })}
                className="w-4 h-4 mt-0.5"
              />
              <div>
                <div className="text-sm font-bold text-slate-800">
                  Blokuj zamówienia (SIM, przeniesienie numeru) do czasu startu
                </div>
                <div className="text-xs text-slate-600 mt-1">
                  Gdy włączone: klienci widzą komunikat „Sprzedaż jeszcze nie wystartowała" zamiast formularza.
                  Blokada odblokowuje się <strong>automatycznie</strong> po dacie startu ustawionej powyżej.
                  Wyłącz, aby ręcznie odblokować zamówienia niezależnie od daty.
                  <br />
                  <span className="text-slate-500">Zabezpieczenie działa też na backendzie — nikt nie może obejść blokady wysyłając POST bezpośrednio.</span>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          <div>
            <label className={labelCls}>Telefon / Infolinia</label>
            <input data-testid="contact-phone" className={inputCls} value={brand.contact.phone} onChange={(e) => setBrand({ ...brand, contact: { ...brand.contact, phone: e.target.value } })} />
          </div>
          <div>
            <label className={labelCls}>Email</label>
            <input data-testid="contact-email" className={inputCls} value={brand.contact.email} onChange={(e) => setBrand({ ...brand, contact: { ...brand.contact, email: e.target.value } })} />
          </div>
          <div>
            <label className={labelCls}>Adres siedziby (max 3 linijki)</label>
            <textarea
              data-testid="contact-address"
              className={inputCls}
              rows={3}
              value={brand.contact.address}
              onChange={(e) => setBrand({ ...brand, contact: { ...brand.contact, address: e.target.value } })}
              placeholder={"Rmobile sp. z o.o.\nul. Przykładowa 12/34\n00-000 Warszawa"}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
